const Environment = {
    coreServiceUrl: process.env.REACT_APP_CORE_SERVICE_URL || 'https://ljkyxjuit3.execute-api.ap-southeast-1.amazonaws.com',
    appServiceUrl: process.env.REACT_APP_APP_SERVICE_URL || 'https://0k225rwb86.execute-api.ap-southeast-1.amazonaws.com',
    socialServiceUrl: process.env.REACT_APP_SOCIAL_SERVICE_URL || '	https://m2s948q1b3.execute-api.ap-southeast-1.amazonaws.com',
    exoseedServiceUrl: process.env.REACT_APP_EXOSEEED_SERVICE_URL || 'https://7arzagasf9.execute-api.ap-southeast-1.amazonaws.com',
    utilServiceUrl: process.env.REACT_APP_UTIL_SERVICE_URL || 'https://0k225rwb86.execute-api.ap-southeast-1.amazonaws.com/mobile',

    locationUrl: process.env.REACT_APP_LOCATION_URL || 'https://exo-core-dev-mainbucket-a3z1hbnal9cb.s3.ap-southeast-1.amazonaws.com',

    apiKey: process.env.REACT_APP_API_KEY || '',
    userPoolId: process.env.REACT_APP_USER_POOL_ID || 'ap-southeast-1_H1Obj42bf',
    userPoolClientId: process.env.REACT_APP_USER_POOL_CLIENT_ID || '1pepqgum4rhek6s0lp6lhbp1ca',
    revenueCatProjectId: process.env.REACT_APP_REVENUE_CAT_PROJECT_ID || '37df6902',
    mapboxKey: process.env.REACT_APP_MAPBOX_KEY || 'pk.eyJ1IjoiZXhvdHJhaWxzIiwiYSI6ImNsODJnemJ5bTBweGgzd21rM3NkZHg1dTcifQ.Z5S3APmFZB4YZ19vEHlXwA',

    trail: process.env.REACT_APP_TRAIL_APP_URL || 'https://exotrails.page.link/ytesNUKrwsTHRSCu5',
    ecoZones: process.env.REACT_APP_ECO_ZONES_APP_URL || 'https://exotrails.page.link/J15E9tuCHELyWYT7A',
    heritage: process.env.REACT_APP_HERITAGE_APP_URL || 'https://exotrails.page.link/J7PiMcWnxkN24nfdA',
    sightseeing: process.env.REACT_APP_SIGHT_SEEING_APP_URL || 'https://exotrails.page.link/s1tnpY53sdNdMA9V9',
    marathonCourse: process.env.REACT_APP_MARATHON_COURSE_APP_URL || 'https://exotrails.page.link/V7VipUR5ni7sd2Uk9',
    marathonTraining: process.env.REACT_APP_MARATHON_TRAINING_APP_URL || 'https://exotrails.page.link/FhmdoecvyG3eGkY3A',
    stay: process.env.REACT_APP_STAY_APP_URL || 'https://exotrails.page.link/aynhpawGL9GAgccy5',
    eatLocal: process.env.REACT_APP_EAT_LOCAL_APP_URL || 'https://exotrails.page.link/K1bC9pFRG12i4sMYA',
};

export default Environment;
